import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withPreference from '../../common/withPreference';
import withOnline from '../../common/withOnline';
import Header from '../../components/Header';
import CopyPreferenceModal from '../../components/Models/CopyPreferenceModal';
import { ALPHANUMERIC, sortData, storeLastVisitedRoute } from '../../common/globals';
import { addPreference, getPreferences } from '../../utils/utils';
import { addBulkPreferences, getAllPreferences, preferencesClear } from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import withUpdatedRoute from '../../common/withUpdatedRoute';

class Preferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      preferencesData: [],
      preferenceSearchResult: [],
      selectedCopyPreference: null,
      search: ''
    };
    this.internalServerErrorModal = null;
  }

  componentDidMount() {
    try {
      this.internalServerErrorModal = new window.bootstrap.Modal(window.$('#internalServerErrorModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getPreferenceData = async () => {
    try {
      const { online, setLoader, notify } = this.props;
      setLoader(true);
      if (online) {
        const preferenceRes = await getPreferences();
        const { message, status, data } = preferenceRes;
        if (status) {
          await preferencesClear();
          if (typeof data !== 'undefined' && data !== null) {
            await addBulkPreferences(data);
          }
          this._fetchLocalPreferences();
        } else {
          notify({ type: 'error', message });
        }
        // setLoader(false);
      } else {
        this._fetchLocalPreferences();
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _fetchLocalPreferences = async () => {
    try {
      const data = await getAllPreferences();
      const finalPreferenceMap = {};
      data.forEach((singlePref) => {
        if (finalPreferenceMap[singlePref.PreferenceName]) {
          finalPreferenceMap[singlePref.PreferenceName].selectedSets.push({
            SetName: singlePref.SetName,
            Quantity: Number(singlePref.Quantity),
            DeviceType: singlePref.DeviceType
          });
        } else {
          const {
            SetName, Quantity, DeviceType, ...rest
          } = singlePref;
          finalPreferenceMap[singlePref.PreferenceName] = { ...rest };
          finalPreferenceMap[singlePref.PreferenceName].selectedSets
            = [{ SetName, Quantity: Number(Quantity), DeviceType }];
        }
      });

      const finalPreferenceList = [];
      for (const key in finalPreferenceMap) {
        if (key !== 'null') {
          if (key !== '') {
            finalPreferenceList.push(finalPreferenceMap[key]);
          }
        }
      }
      const sortedObjs = this.preferenceGroupData(finalPreferenceList);
      this.setState({
        preferencesData: sortedObjs,
        preferenceSearchResult: sortedObjs
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  preferenceGroupData = (preferences) => {
    try {
      // TODO: update the code base on api response
      const data = preferences.reduce((r, e) => {
        const group = (e.PreferenceName !== null) ? e.PreferenceName[0] : '';
        if (!r[group]) r[group] = { group, children: [e] };
        else r[group].children.push(e);
        return r;
      }, {});

      const result = Object.values(data);
      return sortData(result, 'group');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCopyAndSavePreference = (newName) => {
    try {
      const { selectedCopyPreference } = this.state;
      const {
        setPreference, goBack, setGoBack, setLoader, notify, online
      } = this.props;
      const copyPreferenceName = `${selectedCopyPreference.PreferenceName} COPY`;
      selectedCopyPreference.PreferenceName = newName !== '' ? newName.toUpperCase() : copyPreferenceName;
      if (online) {
        setLoader(true);
        addPreference(selectedCopyPreference).then((response) => {
          const { result, message } = response;
          setLoader(false);
          if (result === 'success') {
            selectedCopyPreference.id = selectedCopyPreference.PreferenceName;
            setPreference(selectedCopyPreference);
            goBack.push(window.location.pathname);
            setGoBack(goBack);
            browserHistory.push(`/preferences/${selectedCopyPreference.PreferenceName}`);
          } else {
            this._getPreferenceData();
            notify({ type: 'error', message });
          }
        });
      } else {
        this.internalServerErrorModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = (event) => {
    try {
      let search = '';
      search = event.target.value;
      this.setState({ search }, () => {
        this.searchPreference();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  searchPreference = () => {
    try {
      const { search, preferenceSearchResult } = this.state;
      const searchRes = [];
      preferenceSearchResult.map((preference) => {
        const searchData = new RegExp(search.toUpperCase(), 'g');
        const data = preference.children.filter((item) => (item.PreferenceName !== null ? item.PreferenceName.match(searchData) : ''));
        data.map((item) => {
          searchRes.push(item);
        });
      });
      const sortedObjs = this.preferenceGroupData(searchRes);
      this.setState({
        preferencesData: search !== '' ? sortedObjs : preferenceSearchResult
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCopyPreference = (selectedData) => {
    try {
      this.setState({ selectedCopyPreference: selectedData });
      setTimeout(() => {
        window.$('#copyPrefName').focus();
      }, 500);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onAddNew = () => {
    try {
      const { goBack, setGoBack, setPreference } = this.props;
      setPreference({
        PreferenceName: '',
        CaseType: '',
        Comments: '',
        RepNotes: '',
        selectedSets: []
      });
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditPreference = (data) => {
    try {
      const {
        setPreference, goBack, setGoBack, online, notify
      } = this.props;
      if (online) {
        setPreference({ ...data, id: data.PreferenceName });
        goBack.push(window.location.pathname);
        setGoBack(goBack);
        browserHistory.push(`preferences/${data.PreferenceName}`);
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { setUpdatedRoute } = this.props;
      await this._getPreferenceData();
      storeLastVisitedRoute('/preferences');
      setUpdatedRoute('/preferences');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { preferencesData, search } = this.state;
    return (
      <section className="list-section">
        <Header
          sideMenu
          goForward={{
            title: 'Add <i class="fas fa-plus"></i></a>',
            url: '/preferences/new',
            onGoForward: this._onAddNew
          }}
        />
        <section className="sets-section">
          <div className="container resizer-class">
            <div className="top-block sticky-pref-search">
              <div className="row gx-2">
                <div className="col-12 pt-2 pb-2">
                  <input
                    type="text" className="form-control search-input x-ray-choose-file"
                    placeholder="Search Preferences"
                    onChange={(e) => this._onSearch(e)}
                    value={search}
                  />
                </div>
              </div>
            </div>

            <div className="sets-list-blocks t-b-border-0">
              <div className="sets-list-blocks">
                {preferencesData !== undefined
                  && preferencesData.length > 0 ? preferencesData.map((item, index) => (
                    <div className="sets-block" key={index}>
                      <h4 id={item.group === undefined
                        ? '' : item.group.toLowerCase()}
                      >{item.group}
                      </h4>
                      <ul className="list-unstyled preferences-list" key={index}>
                        {
                          item.children.map((data, key) => (
                            <li key={key} className={`${data.PreferenceName !== null ? '' : 'pref-null'}`}>
                              <div className="right-side">
                                <p style={{
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                  textOverflow: 'ellipsis'
                                }}
                                >
                                  {data.PreferenceName !== null ? data.PreferenceName : ''}
                                </p>
                              </div>
                              <Link
                                className="link-copy" to="#copyPreferenceModal"
                                data-bs-toggle="modal"
                                data-bs-target="#copyPreferenceModal"
                                onClick={() => {
                                  this._onCopyPreference(data);
                                }}
                              ><i className="far fa-copy" />
                              </Link>
                              <Link onClick={() => this._onEditPreference(data)} className="link-edit">
                                <i className="far fa-edit cursor-pointer" />
                              </Link>
                            </li>
                          ))
                        }
                      </ul>
                    </div>
                  )) : <p className="text-center mt-5">No Preferences Found.</p>}
              </div>
            </div>

          </div>
          <ul className="list-unstyled right-filter mt-3">
            {ALPHANUMERIC.map((name, index) => (
              <li key={index}>
                <a href={`/preferences#${name.toLowerCase()}`} key={index}>{name}</a>
              </li>
            ))}
          </ul>
        </section>
        <CopyPreferenceModal
          onSavePreference={this._onCopyAndSavePreference}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'SetInfoForm',
});

export default withOnline(
  withPreference(
    withForm(
      withGoBack(
        withNotify(
          withLoader(
            withUpdatedRoute(
              Preferences
            )
          )
        )
      )
    )
  )
);
